"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualConnectionQueryWrapper = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@apollo/client/react/components");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const renderQueryResult_1 = require("../renderQueryResult");
const ErrorMessageWidgets_1 = require("../widgets/ErrorMessageWidgets");
class VirtualConnectionQueryWrapper extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.renderVirtualConnectionData = (data) => {
            const virtualConnection = data.virtualConnections ? data.virtualConnections[0] : null;
            if (virtualConnection) {
                return this.props.children(virtualConnection);
            }
            else {
                return react_1.default.createElement(data_catalog_shared_1.CenteredMessage, { message: catalog_messages_1.Messages.ErrorItemNotFound() });
            }
        };
    }
    render() {
        return (react_1.default.createElement(components_1.Query, { query: catalog_queries_1.VirtualConnectionDocument, variables: { vizportalUrlId: this.props.vizportalUrlId } }, result => (react_1.default.createElement(renderQueryResult_1.RenderQueryResult, { result: result, renderers: {
                renderLoading: () => react_1.default.createElement(data_catalog_shared_1.CenteredFadeInSpinner, null),
                renderData: this.renderVirtualConnectionData,
                renderNoData: ErrorMessageWidgets_1.renderNoData,
                renderDataWithError: (0, ErrorMessageWidgets_1.createRenderDataWithErrorFunction)(this.renderVirtualConnectionData),
                renderError: ErrorMessageWidgets_1.renderError,
            } }))));
    }
}
exports.VirtualConnectionQueryWrapper = VirtualConnectionQueryWrapper;
//# sourceMappingURL=VirtualConnectionQueryWrapper.js.map